import React from "react";
import { Eyebrow } from "./_shared";

const EXPERIENCE = [
  "Corporate and commercial transactions",
  "Mergers, acquisitions and investments",
  "Commercial contracts and strategic arrangements",
  "Corporate governance and reorganizations",
  "Regulatory and compliance matters",
  "Technology and data-related matters",
  "Business formation and structuring",
  "Risk management and dispute avoidance",
  "Legal support for growing and established businesses",
];

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="py-24 lg:py-32 bg-cream-100"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="mb-14 reveal">
          <Eyebrow>Counsel</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-[62px] tracking-tight text-charcoal leading-[1.05]">
            Experienced Counsel.
            <span className="block">Strategic Perspective.</span>
            <span className="block italic text-sage-600">Practical Results.</span>
          </h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7 reveal">
            <div className="space-y-6 max-w-2xl text-charcoal-muted font-sans text-[16px] leading-[1.75]">
              <p>
                Our counsel bring a breadth of legal experience across
                corporate, commercial and regulatory matters, with a practical
                understanding of the legal and business considerations that
                shape important decisions.
              </p>
              <p>
                We work closely with clients to understand their objectives,
                identify legal and commercial risks, and develop solutions that
                are both legally sound and aligned with their broader goals.
              </p>
              <p>
                Our collective experience includes advising businesses,
                investors, entrepreneurs and organizations on complex
                transactions, commercial arrangements, corporate matters,
                regulatory requirements and other legal issues arising
                throughout the business lifecycle.
              </p>
            </div>

            <div
              className="mt-14 pt-10 border-t border-cream-300"
              data-testid="counsel-collaborative"
            >
              <p className="text-[11px] uppercase tracking-[0.28em] text-ochre-600 font-sans">
                A Collaborative Approach
              </p>
              <h2 className="mt-4 font-serif text-3xl lg:text-4xl text-charcoal leading-tight">
                Effective counsel goes beyond
                <span className="italic text-sage-600"> identifying issues.</span>
              </h2>
              <div className="mt-6 space-y-5 max-w-2xl text-charcoal-muted font-sans text-[16px] leading-[1.75]">
                <p>
                  We believe effective legal counsel goes beyond identifying
                  legal issues. It requires understanding the client's
                  business, anticipating challenges and providing clear,
                  commercially focused advice.
                </p>
                <p>
                  Our counsel collaborate across areas of expertise where a
                  matter requires multidisciplinary input, ensuring that
                  clients receive coordinated advice tailored to the
                  particular circumstances of their business or transaction.
                </p>
              </div>
            </div>

            <div
              className="mt-14 pt-10 border-t border-cream-300"
              data-testid="counsel-objectives"
            >
              <p className="text-[11px] uppercase tracking-[0.28em] text-ochre-600 font-sans">
                Focused on Your Objectives
              </p>
              <div className="mt-6 space-y-5 max-w-2xl text-charcoal-muted font-sans text-[16px] leading-[1.75]">
                <p>
                  Whether advising on a transaction, structuring a new venture,
                  negotiating a commercial arrangement or navigating a complex
                  regulatory issue, our approach is focused on providing clear,
                  practical and responsive legal advice.
                </p>
                <p>
                  We aim to serve as trusted legal advisers to our clients —
                  not simply as legal service providers, but as counsel who
                  understand the commercial context in which legal decisions
                  are made.
                </p>
                <p className="font-serif italic text-2xl lg:text-[26px] text-charcoal not-italic-fallback leading-snug pt-4">
                  <span className="italic">
                    Legal expertise. Commercial understanding.{" "}
                    <span className="text-sage-600">Counsel aligned with your objectives.</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <aside className="lg:col-span-5 reveal lg:pt-2">
            <div
              className="bg-sage-700 text-white p-8 lg:p-10"
              data-testid="counsel-experience"
            >
              <p className="text-[11px] uppercase tracking-[0.28em] text-ochre-500 font-sans">
                Our Experience
              </p>
              <h3 className="mt-3 font-serif text-2xl lg:text-3xl leading-tight">
                Our collective practice experience encompasses:
              </h3>
              <ul className="mt-8 space-y-4">
                {EXPERIENCE.map((item, i) => (
                  <li
                    key={item}
                    className="flex items-start gap-4 font-sans text-[15px] leading-snug text-white/90"
                  >
                    <span className="mt-2 h-1 w-3 shrink-0 bg-ochre-500" aria-hidden="true" />
                    <span>
                      <span className="mr-3 text-[11px] tracking-[0.22em] text-ochre-500 font-sans">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 pl-6 border-l-2 border-ochre-500">
              <p className="font-sans text-[13px] uppercase tracking-[0.28em] text-sage-700">
                Charis <span className="italic">&amp;</span> Mettle
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
